export enum InsuranceRecipient {
  ME = 'Me',
  SPOUSE = 'Spouse',
  PARENT = 'Parent',
  SIBLING = 'Sibling',
  CHILD = 'Child',
  KIN = 'Niece / Nephew',
  OTHERS = 'Others'
}
